import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Career() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getCareer = () => {
    axios
      .post(
        "https://m1blog.aaragroups.com/blog/store-based-jobs-list-api/",
        {},
        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        setData(res.data?.news_details);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const deleteCareer = (id) => {
    axios
      .delete(
        `https://m1blog.aaragroups.com/blog/api/admin/api/job-deatils-api/?id=${id}`,
        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        toast.success(res?.data?.message || "Deleted successfully");
        getCareer();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error deleting job");
      });
  };

  useEffect(() => {
    getCareer();
  }, []);

  return (
    <div className="min-h-screen p-4 sm:p-6 md:p-2 bg-gray-100">
      <p className="my-3 sm:my-0 text-4xl sm:text-5xl text-center text-blue-900 underline">
        Career
      </p>

      {/* Add Button */}
      <div className="flex justify-end mb-2">
        <NavLink to="/addcareer">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Career Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {data?.map((item) => (
          <div
            key={item.id}
            className="flex flex-col bg-white border border-gray-300 rounded-lg shadow-lg p-4"
          >
            <p className="text-xl sm:text-2xl font-bold text-center text-blue-900 underline mb-4">
              {item.Title}
            </p>

            {item.images && (
              <img
                className="w-full h-48 sm:h-56 object-cover rounded mb-4"
                src={`${item.images}?${Date.now()}`}
                alt="Career"
              />
            )}

            <p className="text-sm sm:text-base font-medium text-gray-800 mb-2">
              Exprerence:{item.Experience} Year
            </p>
            <p className="text-sm sm:text-base font-medium text-gray-800 mb-2">
              Location:{item.Location}
            </p>

            <div
              className="text-gray-700 text-sm sm:text-base mb-4"
              dangerouslySetInnerHTML={{ __html: item.Content }}
            />

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-auto">
              <Button
                onClick={() =>
                  navigate(`/addcareer`, {
                    state: item?.id,
                  })
                }
                variant="outlined"
                className="w-full sm:w-auto"
              >
                Update
              </Button>
              <Button
                onClick={() => deleteCareer(item.id)}
                variant="outlined"
                color="error"
                className="w-full sm:w-auto"
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
